<template>
	<div style="width:90%">
		<!-- 查询 -->
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<!-- <el-form-item label="UID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入UID"></el-input>
					</el-form-item>
					<el-form-item label="用户名" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户名"></el-input>
					</el-form-item>
					<el-form-item label="用户手机号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.userPhone" placeholder="请输入用户手机号"></el-input>
					</el-form-item> -->
					<el-form-item label="店铺名称" class='tiny' v-if="userStoreID==0">
						<el-input style="width: 200px;" v-model="searchInfo.storeName" placeholder="请输入店铺名称" >
						</el-input>
					</el-form-item>
					<el-form-item label="采购订单编号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.orderCode" placeholder="请输入采购订单编号">
						</el-input>
					</el-form-item>
					<el-form-item label="渠道:" label-width="80px" v-if="userStoreID==0">
						<el-select v-model="searchInfo.channel" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>
							<!-- WEB=WEB下单、APP=APP下单 -->
							<el-option key="0" label="WEB下单" value="WEB">WEB下单</el-option>
							<el-option key="1" label="APP下单" value="APP">APP下单</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="订单状态:" label-width="80px" >
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>
							<el-option key="0" label="待付款" :value="0">待付款</el-option>
							<el-option key="1" label="待发货" :value="1">待发货</el-option>
							<el-option key="2" label="待收货" :value="2">待收货</el-option>
							<el-option key="3" label="已完成" :value="3">已完成</el-option>
							<el-option key="4" label="退款申请" :value="4">退款申请</el-option>
							<el-option key="5" label="已退款" :value="5">已退款</el-option>
							<el-option key="6" label="部分退款" :value="6">部分退款</el-option>
							<el-option key="7" label="已失效" :value="7">已失效</el-option>
							<el-option key="8" label="驳回" :value="8">驳回</el-option>
						</el-select>
					</el-form-item>
					

					<el-form-item label="时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
							 start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
						</template>
					</el-form-item>
				</el-form>

				<!-- <div style="margin: 20px">
					<div style="font-size: 14px;display: flex;justify-content: start;align-items: center;">
						<div><span style="font-weight: bold">汇总：</span></div>
						<div>
							共: {{ sliderlist.total }} 单
						</div>
						<div style="padding-left:20px;">
							结算价: ￥{{ allData ? allData : 0 | intToFloatfour | cutZero }}
						</div>
					</div>
				</div> -->
			</header>
		</div>
		<!-- 列表展示 -->
		<el-table :data="caiGouOrderList" stripe style="width: 100%" border v-loading="loadingList"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<!-- <el-table-column type="index" align="center" width="90" label="#">
			</el-table-column> -->
			<el-table-column prop="" label="渠道"  align="center"  width="80" :show-overflow-tooltip="true" 
			v-if="userStoreID==0">
				<!-- WEB=WEB下单、APP=APP下单 -->
				<template slot-scope="scope">
					<span v-if="scope.row.channel=='WEB'">WEB下单</span>
					<span v-if="scope.row.channel=='APP'">APP下单</span>
				
				</template>
            </el-table-column>
			<el-table-column prop="caigouUser" label="下单会员" align="center" width="160" :show-overflow-tooltip="true" >
				<!-- <template slot-scope="scope">
					{{ scope.row.userId }}
					<span v-if="scope.row.username">~{{ scope.row.username}}</span>
					<span v-if="scope.row.userPhone">~{{scope.row.userPhone}}</span>
				</template> -->
			</el-table-column>
			<el-table-column prop="storeName" label="店铺名称" align="center" width="140" v-if="userStoreID==0" key="storeName"
			:show-overflow-tooltip="true"></el-table-column>
			<!-- <el-table-column prop="supplierName" label="供应商名称" align="center" width="120" :show-overflow-tooltip="true" >
			</el-table-column> -->
			<el-table-column prop="orderCode" label="订单编号" align="center" width="180" :show-overflow-tooltip="true" >
			</el-table-column>
			<el-table-column prop="orderTotalPrice" label="订单总价(￥)" align="center" width="110" :show-overflow-tooltip="true" >
			</el-table-column>
			<el-table-column prop="status" label="订单状态" align="center" width="80" :show-overflow-tooltip="true" >
				<template slot-scope="scope">
					<span v-if="scope.row.status==0" style="color:#E6A23C;">待付款</span>
					<span v-if="scope.row.status==1" style="color:#409EFF;">待发货</span>
					<span v-if="scope.row.status==2" style="color:#9042bd;">待收货</span>
					<span v-if="scope.row.status==3" style="color:#67C23A;">已完成</span>
					<span v-if="scope.row.status==4" style="color:#41cad7;">退款申请</span>
					<span v-if="scope.row.status==5" style="color:#41cad7;">已退款</span>
					<span v-if="scope.row.status==6" style="color:#41cad7;">部分退款</span>
					<span v-if="scope.row.status==7" style="color:#909399;">已失效</span>
					<span v-if="scope.row.status==8" style="color:#F56C6C;">驳回</span>
					<!-- <span>{{scope.row.status}}</span> -->
				</template>
			</el-table-column>
			<el-table-column prop="payType" label="支付类型" align="center"  width="250" v-if="userStoreID==0" key="payType"> 
                <template slot-scope="scope">
					<p v-if="scope.row.payType=='sand_ali_pay'">杉德支付</p>
					<p v-if="scope.row.payType=='integral'">
						<!-- 积分支付 -->
						{{scope.row.integralName}}：<span>{{scope.row.integralNum}}个{{scope.row.integralPrice!=1?'(￥'+scope.row.integralPrice+'/个)':''}}</span>
					</p>
					<p v-if="scope.row.payType=='wx'">
						<!-- 微信支付 -->
						微信：<span>￥{{scope.row.cashNum}}</span>
					</p>
					<p v-if="scope.row.payType=='alipay'">
						<!-- 支付宝支付 -->
						支付宝：<span>￥{{scope.row.cashNum}}</span>
					</p>
					<p v-if="scope.row.payType=='wxplural'">
						<!-- 微信混合支付 -->
						<span v-if="scope.row.cashNum">
							微信：<span>￥{{scope.row.cashNum}}</span>
						</span>
						<span v-if="scope.row.integralNum">
							{{scope.row.integralName}}：<span>{{scope.row.integralNum}}个{{scope.row.integralPrice!=1?'(￥'+scope.row.integralPrice+'/个)':''}}</span>
						</span>
					</p>
					<p v-if="scope.row.payType=='aliplural'">
						<!-- 支付宝混合支付 -->
						<span v-if="scope.row.cashNum">
							支付宝：<span>￥{{scope.row.cashNum}}</span>
						</span>
						<span v-if="scope.row.integralNum">
							{{scope.row.integralName}}：<span>{{scope.row.integralNum}}个{{scope.row.integralPrice!=1?'(￥'+scope.row.integralPrice+'/个)':''}}</span>
						</span>
					</p>
				</template>
            </el-table-column>
			<el-table-column prop="rewardIntegralNumber" label="赠流量池" align="center" min-width="100" :show-overflow-tooltip="true" >
			</el-table-column>
			<el-table-column prop="address" label="详细地址" align="center" min-width="300" :show-overflow-tooltip="true" >
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="160" :show-overflow-tooltip="true" >
			</el-table-column>
			<el-table-column prop="" label="详情" align="center" width="120" :show-overflow-tooltip="true"
			fixed="right">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="showCaiGou(scope.row)">查看采购清单</el-button>
				</template>
			</el-table-column>

		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px;width:100%;" background :current-page="sliderlist.pageNum" @current-change="pageChange"
		 layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total" @size-change="handleSizeChange">
		</el-pagination>


		<!-- 采购清单详情对话框 -->
		<el-dialog title="采购清单" :visible.sync="caigouDetail" width="70%" :before-close="caigouDetailClose" :close-on-click-modal="false">
			<div>
				<div style="margin-bottom: 20px;">
					<el-form v-model="orderListInfo" label-position="left" inline class="demo-table-expand">
						<el-form-item label="下单会员:">
							<span >{{ orderListInfo.caigouUser}}</span>
						</el-form-item>
						<el-form-item label="下单渠道:">
							<span v-if="orderListInfo.channel=='WEB'">WEB下单</span>
							<span v-if="orderListInfo.channel=='APP'">APP下单</span>
						</el-form-item>
						<el-form-item label="采购单号:">
							<span>{{orderListInfo.orderCode}}</span>
						</el-form-item>
						<el-form-item label="采购单状态:">
							<span v-if="orderListInfo.status==0" style="color:#E6A23C;">待付款</span>
							<span v-if="orderListInfo.status==1" style="color:#409EFF;">待发货</span>
							<span v-if="orderListInfo.status==2" style="color:#9042bd;">待收货</span>
							<span v-if="orderListInfo.status==3" style="color:#67C23A;">已完成</span>
							<span v-if="orderListInfo.status==4" style="color:#41cad7;">退款申请</span>
							<span v-if="orderListInfo.status==5" style="color:#41cad7;">已退款</span>
							<span v-if="orderListInfo.status==6" style="color:#41cad7;">部分退款</span>
							<span v-if="orderListInfo.status==7" style="color:#909399;">已失效</span>
							<span v-if="orderListInfo.status==8" style="color:#F56C6C;">驳回</span>
						</el-form-item>
						<el-form-item label="支付类型:">
							<p v-if="orderListInfo.payType=='sand_ali_pay'">杉德支付</p>
							<p v-if="orderListInfo.payType=='integral'">
								<!-- 积分支付 -->
								{{orderListInfo.integralName}}：<span>{{orderListInfo.integralNum}}个(￥{{orderListInfo.integralPrice}}/个)</span>
							</p>
							<p v-if="orderListInfo.payType=='wx'">
								<!-- 微信支付 -->
								微信：<span>￥{{orderListInfo.cashNum}}</span>
							</p>
							<p v-if="orderListInfo.payType=='alipay'">
								<!-- 支付宝支付 -->
								支付宝：<span>￥{{orderListInfo.cashNum}}</span>
							</p>
							<p v-if="orderListInfo.payType=='wxplural'">
								<!-- 微信混合支付 -->
								<span v-if="orderListInfocashNum">
									微信：<span>￥{{orderListInfo.cashNum}}</span>
								</span>
								<span v-if="orderListInfo.integralNum">
									{{orderListInfo.integralName}}：<span>{{orderListInfo.integralNum}}个(￥{{orderListInfo.integralPrice}}/个)</span>
								</span>
							</p>
							<p v-if="orderListInfo.payType=='aliplural'">
								<!-- 支付宝混合支付 -->
								<span v-if="orderListInfo.cashNum">
									支付宝：<span>￥{{orderListInfo.cashNum}}</span>
								</span>
								<span v-if="orderListInfo.integralNum">
									{{orderListInfo.integralName}}：<span>{{orderListInfo.integralNum}}个(￥{{orderListInfo.integralPrice}}/个)</span>
								</span>
							</p>
						</el-form-item>
						<el-form-item label="详细地址:">
							<span>{{orderListInfo.address}}</span>
						</el-form-item>
						<el-form-item label="创建时间:">
							<span>{{orderListInfo.createTime}}</span>
						</el-form-item>
					</el-form>
					
				</div>
				<el-table :data="orderList" stripe style="width: 100%" border v-loading="loadingDetail"
				element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
					<!-- <el-table-column type="index" align="center" width="90" label="#">
					</el-table-column> -->
				
					<!-- <el-table-column prop="phone" label="收货手机号" align="center" width="" :show-overflow-tooltip="true">
					</el-table-column> -->
					<el-table-column prop="storeName" label="店铺名称" align="center"  v-if="userStoreID==0" key="storeName"
					:show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="supplierName" label="供应商名称" align="center"  :show-overflow-tooltip="true" >
					</el-table-column>
					<el-table-column prop="orderCode" label="订单编号" align="center" :show-overflow-tooltip="true" >
					</el-table-column>
					<el-table-column prop="orderTotalPrice" label="订单总价(￥)" align="center"  :show-overflow-tooltip="true" >
					</el-table-column>
					<el-table-column prop="status" label="订单状态" align="center"  :show-overflow-tooltip="true" >
						<template slot-scope="scope">
							<span v-if="scope.row.status==0" style="color:#E6A23C;">待付款</span>
							<span v-if="scope.row.status==1" style="color:#409EFF;">待发货</span>
							<span v-if="scope.row.status==2" style="color:#9042bd;">待收货</span>
							<span v-if="scope.row.status==3" style="color:#67C23A;">已完成</span>
							<span v-if="scope.row.status==4" style="color:#41cad7;">退款申请</span>
							<span v-if="scope.row.status==5" style="color:#41cad7;">已退款</span>
							<span v-if="scope.row.status==6" style="color:#41cad7;">部分退款</span>
							<span v-if="scope.row.status==7" style="color:#909399;">已失效</span>
							<span v-if="scope.row.status==8" style="color:#F56C6C;">驳回</span>
							<!-- <span>{{scope.row.status}}</span> -->
						</template>
					</el-table-column>
					<!-- <el-table-column prop="type" label="订单类型" align="center"  :show-overflow-tooltip="true" >
						<template slot-scope="scope">
							<span v-if="scope.row.type==0">商城订单</span>
							<span v-if="scope.row.type==16">共享订单</span>
							<span v-if="scope.row.type==17">活动订单</span>
							<span v-if="scope.row.type==19">兑换订单</span>
							<span v-if="scope.row.type==20">分销订单</span>
							<span v-if="scope.row.type==21">采购订单</span>
						</template>
					</el-table-column> -->
					<el-table-column prop="payTime" label="支付时间" align="center" width="160" :show-overflow-tooltip="true" >
					</el-table-column>
					<el-table-column prop="completeTime" label="完成时间" align="center" width="160" :show-overflow-tooltip="true" >
					</el-table-column>
					<el-table-column prop="" label="详情" align="center" width="120" :show-overflow-tooltip="true"
					fixed="right">
						<template slot-scope="scope">
							<el-button size="small" type="text" @click="showContent(scope.row)">查看</el-button>
						
						
							<el-button v-if="scope.row.status==1" size="small" type="text" 
							@click="shipmentsClick(scope.row)">发货</el-button>

							<!-- <el-button v-if="scope.row.status==4" size="small" type="text" @click="disposeSH(scope.row)">处理售后
							</el-button> -->
						</template>
					</el-table-column>

				</el-table>
			</div>
		</el-dialog>


		<!-- 订单详情对话框 -->
		<el-dialog title="订单详情" :visible.sync="dialogVisible" width="60%" :before-close="handleClose" :close-on-click-modal="false">
			<div>
				<div style="margin:10px 0 ;">商品详情</div>
				<div class="orderList">

					<div class="orderxq" v-for="(item,index) in orderInfo.goodsList" :key="index">
						<div>
							<img :src="item.images.split(',')[0]" alt="" style="width:100px;height:100px;">
						</div>
						<div style="margin-left:20px;">
							<p>{{item.goodsName}}</p>
							<p v-if="item.guigeName" style="border: 1px solid red;padding: 5px;color: red;margin: 5px 0;">规格：<span>{{item.guigeName}}</span></p>
							<p>购买数量：{{item.num}}</p>
							<p>单价：￥{{item.price}}</p>
						</div>
					</div>

				</div>
				
				<el-form v-model="orderInfo" label-position="left" inline class="demo-table-expand">
					<el-form-item label="订单号">
						<span>{{orderInfo.orderCode}}</span>
					</el-form-item>
					
					<el-form-item label="支付类型">
						<!-- INTEGRAL("积分支付", "integral"),
						WX("微信支付", "wx"),
						ALIPAY("支付宝", "alipay"),
						WXPLURAL("微信混合支付","wxplural"),
						ALIPLURAL("支付宝混合支付","aliplural"); -->

						<!-- <span v-if="orderInfo.payType=='wx'">微信支付</span>
						<span v-if="orderInfo.payType=='alipay'">支付宝支付</span>
						<span v-if="orderInfo.payType=='integral'">积分抵扣-{{orderInfo.integralName}}</span>
						<span v-if="orderInfo.payType=='wxplural'">微信积分混合支付</span>
						<span v-if="orderInfo.payType=='aliplural'">支付宝混合支付</span> -->
						<p v-if="orderInfo.payType=='sand_ali_pay'">杉德支付</p>
						<p v-if="orderInfo.payType=='integral'">
							<!-- 积分支付 -->
							{{orderInfo.integralName}}：<span>{{orderInfo.integralNum}}个(￥{{orderInfo.integralPrice}}/个)</span>
						</p>
						<p v-if="orderInfo.payType=='wx'">
							<!-- 微信支付 -->
							微信：<span>￥{{orderInfo.cashNum}}</span>
						</p>
						<p v-if="orderInfo.payType=='alipay'">
							<!-- 支付宝支付 -->
							支付宝：<span>￥{{orderInfo.cashNum}}</span>
						</p>
						<p v-if="orderInfo.payType=='wxplural'">
							<!-- 微信混合支付 -->
							<span v-if="orderInfo.cashNum">
								微信：<span>￥{{orderInfo.cashNum}}</span>
							</span>
							<span v-if="orderInfo.integralNum">
								{{orderInfo.integralName}}：<span>{{orderInfo.integralNum}}个(￥{{orderInfo.integralPrice}}/个)</span>
							</span>
						</p>
						<p v-if="orderInfo.payType=='aliplural'">
							<!-- 支付宝混合支付 -->
							<span v-if="orderInfo.cashNum">
								支付宝：<span>￥{{orderInfo.cashNum}}</span>
							</span>
							<span v-if="orderInfo.integralNum">
								{{orderInfo.integralName}}：<span>{{orderInfo.integralNum}}个(￥{{orderInfo.integralPrice}}/个)</span>
							</span>
						</p>
					</el-form-item>

					<el-form-item label="所属区域">
						<span>{{orderInfo.area}}</span>
					</el-form-item>
					<el-form-item label="订单类型">
						<span v-if="orderInfo.type==0">商城订单</span>
						<span v-if="orderInfo.type==16">共享订单</span>
						<span v-if="orderInfo.type==17">活动订单</span>
						<span v-if="orderInfo.type==19">兑换订单</span>
						<span v-if="orderInfo.type==20">分销订单</span>
						<span v-if="orderInfo.type==21">采购订单</span>
					</el-form-item>
					<el-form-item label="订单状态">
						<span v-if="orderInfo.status==0" >待付款</span>
						<span v-if="orderInfo.status==1" >待发货</span>
						<span v-if="orderInfo.status==2" >待收货</span>
						<span v-if="orderInfo.status==3" >已完成</span>
						<span v-if="orderInfo.status==4" >退款申请</span>
						<span v-if="orderInfo.status==5" >已退款</span>
						<span v-if="orderInfo.status==6" >部分退款</span>
						<span v-if="orderInfo.status==7" >已失效</span>
						<span v-if="orderInfo.status==8" >驳回</span>
					</el-form-item>
					<el-form-item label="订单总价">
						<span>￥{{orderInfo.orderTotalPrice}}</span>
					</el-form-item>
					<el-form-item label="收货人">
						<span>{{orderInfo.name}}</span>
					</el-form-item>
					<el-form-item label="联系电话">
						<span>{{orderInfo.phone}}</span>
					</el-form-item>
					<el-form-item label="详细地址">
						<span>{{orderInfo.address}}</span>
					</el-form-item>
					<el-form-item label="快递公司">
						<span>{{orderInfo.expressName}}</span>
					</el-form-item>
					<el-form-item label="快递单号">
						<span>{{orderInfo.expressCode}}</span>
					</el-form-item>
					<el-form-item label="发货人">
						<span>{{orderInfo.sendOpUser}}</span>
					</el-form-item>
					<el-form-item label="购买时间">
						<span>{{orderInfo.createTime}}</span>
					</el-form-item>
					<el-form-item label="发货时间">
						<span>{{orderInfo.sendTime}}</span>
					</el-form-item>
					<el-form-item label="完成时间">
						<span>{{orderInfo.completeTime}}</span>
					</el-form-item>
					<el-form-item label="发货备注">
						<span>{{orderInfo.sendRemark}}</span>
					</el-form-item>
					<el-form-item label="查看物流" v-if="orderInfo.status==2||orderInfo.status==3">
						<span @click="lookexp(orderInfo.expressCode)" 
						style="color: green;border-bottom: 1px solid green;cursor:pointer">立即查看</span>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">关 闭</el-button>
				<!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
			</span>
		</el-dialog>

		<!-- 发货 -->
		<el-dialog style="float:rigin" :title="'发货'" :visible.sync="editDialogVisible" width="50%" :close-on-click-modal="false">

			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<el-form-item label="订单号:">
						<span>{{shipments_orderCode}}</span>
					</el-form-item>
					<el-form-item label="收货人:">
						<span>{{shipments_name}}</span>
					</el-form-item>
					<el-form-item label="收货地址:">
						<span>{{shipments_address}}</span>
					</el-form-item>
					<el-form-item label="发货方式" >
						<el-select clearable v-model="expressType" placeholder="请选择发货方式"
							style="width:200px;margin-right:10px;">
							<el-option clearable label="快递" :value="1"></el-option>
							<el-option clearable label="自提" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<div v-if="expressType==1">
						<el-form-item label="物流公司:" style="width: 40%;">
							<el-select v-model="storeOrder.expressId" placeholder="请选择" style="width: 100%;">
								<el-option :key="index" :label="value.expressName" :value="value.id" v-for="(value,index) in sysExpressList"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="快递单号:" style="width: 40%;" class="redItem">
							<el-input type="text" v-model="storeOrder.expressCode" placeholder="请输入快递单号" />
						</el-form-item>
					</div>
					<el-form-item label="发货备注:">
						<el-col :span="15">
							<el-input type="text" v-model="storeOrder.sendRemark" placeholder="请输入发货备注(非必填)" />
						</el-col>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="editDialogVisible = false">取 消</el-button>
				<el-button type="primary" :loading="loadingShipments" @click="shipments">确 认</el-button>
			</div>
		</el-dialog>

		<!-- 查看物流 -->
		<el-dialog style="float:rigin;overflow-y: scroll;" title="物流详情" :visible.sync="ExpDialog" width="60%"
			:close-on-click-modal="false">
				<el-steps :active="wudetail.length" align-center direction="vertical">
				  <el-step v-for="(item,index) in wudetail" :key="index"  :title="item.context" :description="item.ftime"></el-step>
				</el-steps>
		</el-dialog>


		<!-- 处理售后 -->
		<el-dialog style="float:rigin" title="处理售后" :visible.sync="disposeDialog" width="30%"
			:close-on-click-modal="false">
			<div class="app-container" style="text-align: center;">
				<el-form label-width="120px" size="medium">
					<el-form-item label="售后原因:">
						<span>{{afterSaleInfo.reason}}</span>
					</el-form-item>
					<el-form-item label="退款总金额(￥):">
						<span>{{afterSaleInfo.amount}}</span>
					</el-form-item>
                    <el-form-item label="处理结果:">
						<el-radio-group v-model="disposeType">
                            <el-radio :label="2">同意退款</el-radio>
                            <el-radio :label="3">驳回</el-radio>
                        </el-radio-group>
					</el-form-item>
					<el-form-item label="驳回原因:" v-if="disposeType==3">
						<el-col :span="15">
							<el-input type="textarea" :rows="2" v-model="disposeReason" placeholder="请输入驳回原因" />
						</el-col>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="disposeDialog = false">取 消</el-button>
				<el-button type="primary" @click="disposeSumiet" :loading="disposeSumietLoading">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				orderList: [],
				caiGouOrderList: [],
				dialogVisible: false,
				loading:false,
				editDialogVisible: false,
				searchInfo: {
					channel: '',
					status: '',
					type: '',
				},
				orderInfo: {},
				sliderlist: {},
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				provinceList: {},
				cityList: {},
				districtList: {},
				sysExpressList: [],
				storeOrder: {},
				shipments_orderCode:'',
				shipments_name:'',
				shipments_address:'',
				loadingShipments: false,
				expressType:'',
				ExpDialog: false , //查看物流弹窗
				wudetail:[{}], //查看物流数据

				userStoreID: '', //用户ID

				tableKey: '',

				allData: 0,


				disposeDialog: false, //处理售后弹窗
				afterSaleInfo: {}, // 售后记录数据
				disposeType: 2,//处理结果类型
				disposeReason: '', //驳回原因
				disposeSumietLoading: false, //售后处理结果按钮


				caigouDetail: false,
				loadingList: false,
				loadingDetail: false,

				caigouOrderId: 0,

				orderListInfo: {},
			};
		},
		filters: {
			intToFloatfour(val) {
				return (Math.floor(Number(val) * 10000) / 10000).toFixed(4)
			},
			cutZero(old) {
				//拷贝一份 返回去掉零的新串
				old = old + ""
				var newstr = old
				//循环变量 小数部分长度
				var i = 0
				var leng = old.length - old.indexOf(".") - 1
				//判断是否有效数
				if (old.indexOf(".") > -1) {
					//循环小数部分
					for (i = leng; i > 0; i--) {
						//如果newstr末尾有0
						if (newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
							var k = newstr.lastIndexOf("0")
							//如果小数点后只有一个0 去掉小数点
							if (newstr.charAt(k - 1) == ".") {
								return newstr.substring(0, k - 1)
							} else {
								//否则 去掉一个0
								newstr = newstr.substring(0, k)
							}
						} else {
							//如果末尾没有0
							return newstr
						}
					}
				}
				return old
			}

		},
		methods: {
			caigouDetailClose(){
				this.caigouDetail = false;
			},
			showCaiGou(row){
				this.caigouDetail = true;
				this.orderList = []
				
				this.caigouOrderId = row.id;
				this.orderListInfo = row

				this.getGoodsList()
			},
			getGoodsList(){
				this.loadingDetail = true;
				let data={
					caigouOrderId: this.caigouOrderId
				}
				this.$api.caiGouInventoryList(data).then((res => {
					// console.log('表格数据--',res)
					if (res.state == 'success') {
						this.orderList = res.data.list
					}else{
						this.$message.error(res.message);
					}
					this.loadingDetail = false;
				}))
			},
			disposeSH(item){ //处理弹窗
				this.disposeReason = ""
				let data = {
					pageNum: 1,
                    pageSize: 10,
                    orderCode: item.orderCode
                }
                // this.$encrypt(data)
				this.$api.orderAfterSaleListPc(data).then((res => {
					// res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.afterSaleInfo = res.data.list[0]
						// console.log('售后详情---', this.afterSaleInfo)
					}
				}))
				this.disposeDialog = true;
			},
			disposeSumiet(){ // 售后处理确认
				this.disposeSumietLoading = true;
				let data={
                    id: this.afterSaleInfo.id,
                    status: this.disposeType //类型: 2(同意) 3(不同意)
                }
                if(this.disposeType == 3){
                    data.rejectReason = this.disposeReason; //驳回理由
                }
				this.$api.disposeOrderAfterSalePc(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.storeOrderList();
						this.disposeDialog = false;
					} else {
						this.$message.error(res.message);
                    }
                    this.disposeSumietLoading = false
				})
				
			},
			
			handleTabsClick(tab, event) {
				// 每次切换tab的时候，改变tableKey的值
				this.tableKey = new Date()+'' // 解决切换tab表格列渲染错乱问题
			},
			lookexp(id){ //查看物流
				this.$api.lookExpress(id).then(res=>{
					if(res.state=='success'){
						this.ExpDialog=true
						this.wudetail=JSON.parse(res.data.detail).reverse()
					}else{
						this.$message.error(res.message);
					}
				})
			},
			shipmentsClick(item){ //表格点击发货
				// console.log('点击的表格数据---',item)
				this.storeOrder = {};	
				this.storeOrder.id = item.id;
				this.storeOrder.status = 2;
				this.storeOrder.storeId = item.storeId;
				this.shipments_orderCode = item.orderCode;
				this.shipments_address = item.address;
				this.expressType = '';
				this.$api.findOrderInfo(item.id).then((res) => { //查询订单详情
					if (res.state == 'success') {
						this.shipments_name = res.data.name+"-"+res.data.phone;
						this.editDialogVisible = true;
					}
				})
				
			},
			shipments() {
				this.loadingShipments=true
				let data={}
				if(this.expressType==2){ //自提
					data = {
						sendRemark: this.storeOrder.sendRemark,
						expressId: 1,
						storeId: this.storeOrder.storeId,
						status: 3,
						id: this.storeOrder.id
					}
				}else{ //快递
					data = {
						expressCode: this.storeOrder.expressCode,
						sendRemark: this.storeOrder.sendRemark,
						// sendOpUser: this.sendOpUser,//发货人
						expressId: this.storeOrder.expressId,
						storeId: this.storeOrder.storeId,
						status: 2,
						id: this.storeOrder.id
					}
				}
				// this.storeOrder
				this.$api.orderShipments(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false;
						this.loadingShipments=false
						this.getGoodsList()
						this.storeOrderList()
					} else {
						this.$message.error(res.message);
						this.loadingShipments=false
					}
				})
			},
			// 查询
			search() {
				this.page.pageNum = 1;
				this.storeOrderList()

			},
			// 清空
			empty() {
				this.searchInfo = {}

			},
			storeOrderList() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,

					// username: this.searchInfo.username,
					// userId: this.searchInfo.userId,
					// userPhone: this.searchInfo.userPhone,
					// type: this.searchInfo.type,
					// provinceId: this.searchInfo.provinceId,
					// cityId: this.searchInfo.cityId,
					// areaId: this.searchInfo.areaId,

					storeName: this.searchInfo.storeName,
					orderCode: this.searchInfo.orderCode,
					status: this.searchInfo.status,
					channel: this.searchInfo.channel,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.loadingList = true;
				this.$api.caiGouOrderList(data).then((res => {
					// console.log('表格数据--',res)
					if (res.state == 'success') {
						// this.orderList = res.data.list
						this.caiGouOrderList = res.data.list
						this.sliderlist = res.data
						// console.log(this.sliderlist)

					}
					this.loadingList = false;
				}))

				// this.$api.getStoreOrderTotal(data).then((res => {
				// 	res=JSON.parse(this.$decrypt(res.data))
				// 	// console.log('汇总--',res)
				// 	if (res.state == 'success') {
				// 		this.allData = res.data
				// 		// console.log(this.sliderlist)

				// 	}
				// }))
				
			},
			getAreasList(){
				//查询省
				this.$api.getAreasFive(0).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.provinceList = res.data
						//  console.log(this.provinceList)
					}
				})
			},
			//查询市
			provinceFocus(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.province = obj.name
				this.orderInfo.cityId = ""
				// this.setTLevelData.areaId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.city = obj.name
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}

			},

			districtFcus(e) {
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.area = obj.name
			},
			// 订单详情查询
			showContent(row) {
				let data = {
					id: row.id
				}
				this.$api.findOrderInfo(row.id).then((res) => {
					if (res.state == 'success') {
						this.orderInfo = res.data
						// console.log(this.orderInfo)
						this.dialogVisible = true

					}
				})
			},
			handleClose() {
				this.dialogVisible = false
			},
			pageChange(data) {
				this.page.pageNum = data
				this.storeOrderList();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.storeOrderList()
			},
			logInUserInfo(){ //查询登录人信息
				this.$api.getUserInfo(this.$encrypt({})).then(res => {
					res.data = JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						// console.log('登录人信息---', res.data )
						// supplierId(有值就是供应商)
						this.userStoreID = res.data.storeId; // storeId：0(平台)   
					}
				})
				
			}
		},

		created() {
			this.storeOrderList();
			this.getAreasList();
			this.logInUserInfo()
		},
		mounted() {
			this.$api.sysExpressList({}).then((res) => {
				if (res.state == 'success') {
					this.sysExpressList = res.data.list
				}
			})
		}
	};
</script>

<style>
	.orderxq {
		display: flex;
		width: 50%;
		align-items: flex-start;

	}

	.orderList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

	}
</style>
